import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/core/app-config/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LabConfiguration } from '../models/lab-configuration.model';
import { Address } from 'src/app/shared/models/address';
import { CountryAddressFormatRequest } from '../models/country-address-format-request.model';
import { DefaultPurchaseOrder } from '../models/default-purchase-order';

@Injectable({
  providedIn: 'root'
})
export class LabConfigurationService {

  constructor(
    private httpClient: HttpClient,
    private appConfigService: AppConfigService) {
  }

  private labCode: string;

  get LabCode(): string {
    return this.labCode;
  }

  set LabCode(labCode: string) {
    this.labCode = labCode;
  }

  getLabConfiguration(cache = false): Observable<LabConfiguration> {
    return this.getData<LabConfiguration>(`logistics/configurations/labSites/${this.labCode}`, cache);
  }

  getFormattedAddress(request: CountryAddressFormatRequest): Observable<any> {
    const apiUrl = `formattedAddress`;
    return this.postData(request, apiUrl);
  }

  getDefaultPurchaseOrder(accountCode: string): Observable<DefaultPurchaseOrder> {
    const apiUrl = `accounts/${accountCode}/defaultPurchaseOrders`;
    return this.getData<DefaultPurchaseOrder>(apiUrl);
  }

  getData<T>(apiUrl: string, cache = false): Observable<T> {
    const url = this.appConfigService.configuration.apiConfig.labConfigQueryBaseUrl + apiUrl;

    let headers: HttpHeaders;
    if (cache) {
      headers = new HttpHeaders({ 'cache-response': 'true' });
    }

    return this.httpClient.get<T>(url, { headers });
  }

  private postData<T>(data: T, apiUrl: string, loading = true): Observable<T> {
    const url = this.appConfigService.configuration.apiConfig.labConfigQueryBaseUrl + apiUrl;
    let headers: HttpHeaders;
    if (!loading) {
      headers = new HttpHeaders({ 'no-loading': 'true' });
    }
    return this.httpClient.post<T>(url, data, { headers });
  }
}
